export default __webpack_public_path__ + "neighborhoods-guide-banner.svg?eb4000e81a7e8201471b98c7a542935c";